import React from 'react';
import { Box, Typography } from '@mui/material';
import config from '@/config';

type BackgroundErrorPanelProps = {
  imageSrc: string;
  altText: string;
  backgroundBoxStyles?: object;
  contentBoxStyles?: object;
  title: string;
  message: React.ReactElement;
  isTitleUnderlined?: boolean;
};

export const BackgroundErrorPanel = (props: BackgroundErrorPanelProps) => {
  const {
    imageSrc,
    altText,
    backgroundBoxStyles,
    contentBoxStyles,
    title,
    message,
    isTitleUnderlined = false,
  } = props;
  const email = config.supportEmail;
  const aboutUs = config.aboutUsUrl;
  return (
    <>
      <Box sx={backgroundBoxStyles}>
        <img
          src={imageSrc}
          alt={altText}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 2 }}
        >
          <Box>
            <a href={aboutUs} style={{ marginRight: 4 }}>
              About Us
            </a>
            <a href={`mailto:${email}`}>Contact Us</a>
          </Box>
        </Box>
      </Box>
      <Box sx={contentBoxStyles}>
        <Box>
          <Typography
            variant="h4"
            sx={{
              marginBottom: 3,
              fontSize: '1.5rem',
              wordWrap: 'break-word',
              textDecoration: isTitleUnderlined ? 'underline' : 'none',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              marginBottom: { xs: 2, sm: 3 },
              fontSize: { xs: '0.875rem', sm: '1rem', md: '1.25rem' },
              wordWrap: 'break-word',
            }}
          >
            {message}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
